import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";

import { Form, Input, Button, message, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import useSelection from "antd/es/table/hooks/useSelection";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest, postRequestFormData } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { selectStyle } from "../../css/styles";
import AgreementHtml from "./AgreementHtml/AgreementHtml";
import { yyyymmdd } from '../../config/functions'
const { Option } = Select;


const NewAgreement = () => {


    const ids = useParams();
    console.log('ids', ids)
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);
    const [form] = Form.useForm();

    const [clients, setClients] = useState([]);
    const [clientsTemp, setClientsTemp] = useState([]);
    const [selectedClient, setSelectedClient] = useState({});
    const [vehicles, setVehicles] = useState([]);
    const [vehiclesTemp, setVehiclesTemp] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState({});
    const [startDate, setStartDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [agreementType, setAgreementType] = useState('');
    const [endDate, setEndDate] = useState();
    const [editCustomer, setEditCustomer] = useState(false);
    const [custEmail, setCustEmail] = useState('');
    const [custPhone, setCustPhone] = useState('');
    const [custLicense, setCustLicense] = useState('');
    const [custName, setCustName] = useState('');
    const [contractAmount, setContractAmount] = useState(0);
    const [initialDeposit, setInitialDeposit] = useState();
    const [kinsInfo, setKinsInfo] = useState({
        fullName: '',
        address: '',
        phone: '',
        email: '',
        relation: ''
    });

    const [rentalInfo, setRentalInfo] = useState({
        name: '',
        signatures: {}
    })
    const [rentalSign, setRentalSign] = useState();


    const getClientsAndVehicles = async () => {

        const onSuccess = (res) => {
            if (ids.cust_id && res.data?.clients?.length) {
                const client = res.data?.clients[0]
                setSelectedClient(client);
                setKinsInfo({
                    ...kinsInfo,
                    fullName: client?.kins_name,
                    email: client?.kins_email,
                    relation: client?.kins_relation,
                    address: client?.address,
                    phone: client?.kins_phone
                });
                setCustName(client?.name);
                setCustEmail(client?.email);
                setCustPhone(client?.phone);
                setCustLicense(client?.license_number);

            }
            else {
                setClients(res.data?.clients);
                setClientsTemp(res.data?.clients);
            }
            if (ids.veh_id && res.data?.vehicles?.length) {
                setSelectedVehicle(res.data?.vehicles[0]);
                setContractAmount(res.data?.vehicles[0]?.rent);
            }
            else {
                setVehicles(res.data?.vehicles);
                setVehiclesTemp(res.data?.vehicles);
            }

        }

        const onError = (err) => {
            console.log('err', err);
        }

        dispatch(setLoader(true));
        const body = {
            token: user?.token,
            cust_id: ids.cust_id ?? null,
            veh_id: ids.veh_id ?? null,
            // user?.token
        }

        await postRequest(body, apiRoutes.getClientsAndVehicles, onSuccess, onError)

    }


    const onFinish = async () => {

        if (!selectedClient?._id) return message.error('Please select a client');
        if (!selectedVehicle?.veh_id) return message.error('Please select a vehicle');
        if (!startDate) return message.error('Please select start date');
        if (!startTime) return message.error('Please select start time');
        // if (!agreementType) return message.error('Please select agreement type');
        if (!endTime) return message.error('Please select end time');
        if (!endDate) return message.error('Please select end date');
        if (endDate < startDate) return message.error('End date cannot be less than start date');
        if (!contractAmount) return message.error('Please enter contract amount');
        if (!initialDeposit) return message.error('Please enter initial deposit');

        if (!selectedClient?.kins_name && !kinsInfo.fullName) return message.error('Please enter kins name');
        if (!selectedClient?.kins_phone && !kinsInfo.phone) return message.error('Please enter kins phone');
        if (!selectedClient?.kins_email && !kinsInfo.email) return message.error('Please enter kins email');
        if (!selectedClient?.kins_relation && !kinsInfo.relation) return message.error('Please enter kins relation');
        window.scroll(0, 0);
        try {
            const body = {

                token: user?.token,
                veh_id: selectedVehicle?.veh_id,
                cust_id: selectedClient?._id,
                start_date: startDate,
                expected_end_date: endDate,
                start_time: startTime,
                end_time: endTime,
                contract_type: agreementType,
                booking_id: ids.booking_id ?? null,
                contract_amount: contractAmount,
                initial_deposit: initialDeposit,

                kins_full_name: kinsInfo.fullName,
                kins_email: kinsInfo.email,
                kins_phone: kinsInfo.phone,
                kins_address: kinsInfo.address,
                kins_relation: kinsInfo.relation,
                rental_name: rentalInfo.name,
                rental_signature: rentalSign
            }

            console.log('body', body);
            const onSuccess = (res) => {
                message.success(res.message);
                navigate('/agreements');
                dispatch(setLoader(false))
            }
            const onError = (res) => {
                console.log('error', res);
                message.error(res.data?.error);
                dispatch(setLoader(false))
            }

            dispatch(setLoader(true))
            await postRequestFormData(body, apiRoutes.generateAgreement, onSuccess, onError);
        }
        catch (err) {
            console.log('err', err)
            dispatch(setLoader(false))
        }
        return;



        // navigate('/generate-agreement', {
        //     state: {
        //         client: selectedClient,
        //         vehicle: selectedVehicle,
        //         startDate,
        //         startTime,
        //         // agreementType,
        //         endTime,
        //         expectedEndDate: endDate,
        //         bookingId: ids.booking_id ?? null,
        //         contract_amount: contractAmount,
        //         initial_deposit: initialDeposit
        //     }
        // });



    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const updateCustomer = async () => {

        const onSuccess = () => {
            message.success('Customer updated successfully');
            getClientsAndVehicles();
            setEditCustomer(false);
            const selected = {
                ...selectedClient,
                name: custName,
                email: custEmail,
                phone: custPhone,
                license_number: custLicense
            }
            setSelectedClient(selected);
        }
        const onError = (err) => {
            console.log('err', err);
            dispatch(setLoader(false));
            message.error('Failed to update customer');
        }
        const body = {
            token: user?.token,
            cust_id: selectedClient?._id,
            name: custName,
            email: custEmail,
            phone: custPhone,
            license_number: custLicense
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.updateCustomer, onSuccess, onError);


    }

    useEffect(() => {
        getClientsAndVehicles();
    }, [])


    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Add new agreement
                        </span>
                        <Form
                            style={{ width: "100%", }}
                            layout="vertical"
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            initialValues={{
                                clientName: selectedClient?.name,
                                clientEmail: selectedClient?.email,
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Client Information</Typography>
                                    {
                                        selectedClient?._id && (
                                            <div style={{ marginRight: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                {
                                                    editCustomer && (
                                                        <div
                                                            onClick={() => setEditCustomer(false)}
                                                            style={{ cursor: 'pointer', marginRight: 20 }}
                                                        >
                                                            <Typography style={{ color: appColors.secondary, fontFamily: 'Poppins' }}>Cancel</Typography>
                                                        </div>
                                                    )
                                                }
                                                <div
                                                    onClick={() => {
                                                        editCustomer ? updateCustomer() : setEditCustomer(true)
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Typography style={{ color: editCustomer ? '#52FF33' : appColors.white, fontFamily: 'Poppins' }}>{editCustomer ? 'Save' : 'Edit'}</Typography>
                                                </div>

                                            </div>
                                        )
                                    }

                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    {editCustomer ? <Form.Item
                                        name="clientName"
                                    >
                                        <Typography style={labelStyle}>Name</Typography>
                                        <Input
                                            onChange={(e) => setCustName(e.target.value)}
                                            disabled={!editCustomer}
                                            className="textInput"
                                            value={custName}
                                        />
                                    </Form.Item>
                                        :
                                        <Form.Item
                                            style={selectStyle}
                                            name="clientName"
                                        >
                                            <Typography style={labelStyle}>Name</Typography>
                                            <Select

                                                showSearch
                                                filterOption={false}
                                                onSearch={(inputValue) => {
                                                    let value = inputValue.toLowerCase();
                                                    let filtered = clientsTemp?.filter((v, i) => v.name.toLowerCase().includes(value) || v.email.toLowerCase().includes(value) || v.phone.toLowerCase().includes(value));
                                                    setClients(filtered);
                                                }}


                                                disabled={ids.cust_id}
                                                value={selectedClient?.name}
                                                className="textInput"
                                                placeholder="Select customer"
                                                onChange={(value) => {
                                                    let client = clients?.find((v, i) => v._id == value);
                                                    setSelectedClient(client);
                                                    setCustName(client?.name);
                                                    setCustEmail(client?.email);
                                                    setCustPhone(client?.phone);
                                                    setCustLicense(client?.license_number);
                                                    setKinsInfo({
                                                        ...kinsInfo,
                                                        fullName: client?.kins_name,
                                                        email: client?.kins_email,
                                                        relation: client?.kins_relation,
                                                        address: client?.address,
                                                        phone: client?.kins_phone
                                                    });

                                                }}
                                            >
                                                {
                                                    clients?.length && clients?.map((v, i) => {
                                                        return (
                                                            <>
                                                                <Option value={v._id}>{v.name} ({v.phone}) </Option>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {/* <Option value={selectedClient._id}>{selectedClient.name}</Option> */}

                                            </Select>
                                        </Form.Item>
                                    }

                                    <Form.Item
                                        name="clientEmail"
                                    >
                                        <Typography style={labelStyle}>Email</Typography>
                                        <Input
                                            onChange={(e) => setCustEmail(e.target.value)}
                                            disabled={!editCustomer}
                                            className="textInput"
                                            value={custEmail}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientPhone"
                                    >
                                        <Typography style={labelStyle}>Phone</Typography>
                                        <Input
                                            onChange={(e) => setCustPhone(e.target.value)}
                                            disabled={!editCustomer}
                                            className="textInput"
                                            value={custPhone}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientLicense"
                                    >
                                        <Typography style={labelStyle}>License number</Typography>
                                        <Input
                                            onChange={(e) => setCustLicense(e.target.value)}
                                            disabled={!editCustomer}
                                            className="textInput"
                                            value={custLicense}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            {/* CONTRACT INFORMATION */}
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 20, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Agreement Information</Typography>
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    <Form.Item
                                        style={selectStyle}
                                        name="clientName"
                                    >
                                        <Typography style={labelStyle}>Vehicle name</Typography>
                                        <Select
                                            showSearch
                                            filterOption={false}
                                            onSearch={(inputValue) => {
                                                let value = inputValue.toLowerCase();
                                                let filtered = vehiclesTemp?.filter((v, i) => v.veh_name.toLowerCase().includes(value) || v.reg_no.toLowerCase().includes(value));
                                                setVehicles(filtered);
                                            }}
                                            disabled={ids.veh_id}
                                            value={selectedVehicle?.veh_name}
                                            className="textInput"
                                            placeholder="Select vehicle"
                                            onChange={(value) => {
                                                let vehicle = vehicles?.find((v, i) => v.veh_id == value);
                                                setSelectedVehicle(vehicle);
                                                setContractAmount(vehicle?.rent);
                                            }}
                                        >
                                            {
                                                vehicles?.length && vehicles?.map((v, i) => {
                                                    return (
                                                        <>
                                                            <Option value={v.veh_id}>{v.veh_name} ({v.reg_no}) </Option>
                                                        </>
                                                    )
                                                })
                                            }

                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        name="rent"
                                    >
                                        <Typography style={labelStyle}>Rent/Weekly</Typography>
                                        <Input
                                            onChange={(e) => setContractAmount(e.target.value)}
                                            className="textInput"
                                            value={contractAmount}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="agreementStartingDate"
                                    >
                                        <Typography style={labelStyle}>Initial deposit</Typography>
                                        <Input
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setInitialDeposit(value);
                                            }}
                                            className="textInput"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="agreementStartingDate"
                                    >
                                        <Typography style={labelStyle}>Start date</Typography>
                                        <Input
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const _format = yyyymmdd(value);
                                                setStartDate(_format)
                                            }}
                                            type="date"
                                            className="textInput"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="agreementStartingDate"
                                    >
                                        <Typography style={labelStyle}>Start time</Typography>
                                        <Input
                                            onChange={(e) => setStartTime(e.target.value)}
                                            type="time"
                                            className="textInput"
                                        />
                                    </Form.Item>



                                    <Form.Item
                                        name="agreementEndTime"
                                    >
                                        <Typography style={labelStyle}>Expected end date</Typography>
                                        <Input
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const _format = yyyymmdd(value);
                                                setEndDate(_format)
                                            }}
                                            type="date"
                                            // value={endDate}
                                            // disabled={true}
                                            className="textInput"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="agreementEndTime"
                                    >
                                        <Typography style={labelStyle}>End time</Typography>
                                        <Input
                                            onChange={(e) => setEndTime(e.target.value)}
                                            type="time"
                                            className="textInput"
                                        />
                                    </Form.Item>

                                    <div style={{ width: 250 }}></div>


                                </div>
                            </div>

                            {/* KINS INFORMATION */}
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 20, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Kin's information</Typography>
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    <Form.Item
                                        name="fullname"
                                    >
                                        <Typography style={labelStyle}>Full Name</Typography>
                                        <Input
                                            // disabled
                                            onChange={(e) => {
                                                setKinsInfo({
                                                    ...kinsInfo,
                                                    fullName: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={kinsInfo.fullName ?? selectedClient?.kins_name}
                                        // defaultValue={selectStyle?.kins_name}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="rent"
                                    >
                                        <Typography style={labelStyle}>Address</Typography>
                                        <Input
                                            // disabled
                                            onChange={(e) => {
                                                setKinsInfo({
                                                    ...kinsInfo,
                                                    address: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={kinsInfo.address ?? selectedClient?.kins_address}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="agreementStartingDate"
                                    >
                                        <Typography style={labelStyle}>Phone No</Typography>
                                        <Input
                                            // disabled
                                            onChange={(e) => {
                                                setKinsInfo({
                                                    ...kinsInfo,
                                                    phone: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={kinsInfo.phone ?? selectedClient?.kins_phone}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="agreementStartingDate"
                                    >
                                        <Typography style={labelStyle}>Email</Typography>
                                        <Input
                                            // disabled
                                            onChange={(e) => {
                                                setKinsInfo({
                                                    ...kinsInfo,
                                                    email: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={kinsInfo.email ?? selectedClient?.kins_email}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="agreementStartingDate"
                                    >
                                        <Typography style={labelStyle}>Relation to renter</Typography>
                                        <Input
                                            // disabled
                                            onChange={(e) => {
                                                setKinsInfo({
                                                    ...kinsInfo,
                                                    relation: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={kinsInfo.relation ?? selectedClient?.kins_relation}
                                        />
                                    </Form.Item>
                                    <div style={{ width: 250 }}></div>


                                </div>
                            </div>

                            {/* Rental INFORMATION */}
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 20, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>On behalf of Vertex Cars</Typography>
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    <Form.Item
                                        name="fullname"
                                    >
                                        <Typography style={labelStyle}>Full Name</Typography>
                                        <Input
                                            onChange={(e) => {
                                                setRentalInfo({
                                                    ...rentalInfo,
                                                    name: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={rentalInfo.name}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        // label="Upload Images" 
                                        name="images" valuePropName="fileList">
                                        <Typography style={labelStyle}>Signature Image</Typography>
                                        <input type="file" onChange={(e) => {
                                            setRentalSign(e.target.files[0]);
                                            const file = e.target.files[0]; // Assuming you only select one file
                                            if (file) {
                                                const reader = new FileReader();
                                                reader.onload = (event) => {
                                                    setRentalInfo({
                                                        ...rentalInfo,
                                                        signatures: event.target.result // Update rentalInfo with the data URL of the selected file
                                                    });
                                                };
                                                reader.readAsDataURL(file); // Convert file to data URL
                                            }


                                            // setRentalInfo({
                                            //     ...rentalInfo,
                                            //     signatures: e.target.files
                                            // })
                                        }} />

                                    </Form.Item>
                                    <div style={{ width: 250 }}></div>

                                    <div style={{ width: 250 }}></div>

                                    {/* <Form.Item
                                        name="rent"
                                    >
                                        <Typography style={labelStyle}>Signature Image</Typography>
                                        <Input
                                            onChange={(e) => {
                                                setKinsInfo({
                                                    ...kinsInfo,
                                                    address: e.target.value
                                                })
                                            }}
                                            className="textInput"
                                            value={kinsInfo.address}
                                        />
                                    </Form.Item> */}
                                    <div style={{ width: 250 }}></div>


                                </div>
                            </div>







                        </Form>
                    </div>
                </div>

                <AgreementHtml
                    // rental_sign=""
                    rental_name={rentalInfo.name}
                    rental_sign={rentalInfo.signatures}
                    renter_name={custName}
                    postal_code={selectedClient?.postal_code}
                    license_number={custLicense}
                    license_expiry={selectedClient?.license_exp_date}
                    address={selectedClient?.address}
                    phone={selectedClient?.phone}
                    email={selectedClient?.email}
                    make={selectedVehicle?.make}
                    model={selectedVehicle?.model}
                    reg_no={selectedVehicle?.reg_no}
                    color={selectedVehicle?.color}
                    fuel_type={selectedVehicle?.fuel_type}
                    start_date={startDate}
                    end_date={endDate}
                    start_time={startTime}
                    end_time={endTime}
                    rent={contractAmount}
                    deposit={initialDeposit}
                    renter_sign=""
                    kinsName={kinsInfo?.fullName ?? selectedClient.kins_name}
                    dob={selectedClient.dob}
                    kinsPhone={kinsInfo?.phone ?? selectedClient.kins_phone}
                    kinsAddress={kinsInfo.address ?? selectedClient.kins_address}
                    kinsEmail={kinsInfo.email ?? selectedClient.kins_email}
                    renterRelation={kinsInfo.relation ?? selectedClient.kins_relation}
                />
                <Form.Item
                    style={{ textAlign: 'center', }}

                >
                    <Button
                        onClick={() => onFinish()}
                        style={{
                            height: 40, backgroundColor: appColors.primary, marginTop: 20,
                            fontFamily: 'Poppins', fontSize: 14, fontWeight: 600, width: 200
                        }}
                        type="primary"
                        htmlType="submit">

                        Next
                    </Button>
                </Form.Item>
            </ThemeProvider>
        </>
    )

}



const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default NewAgreement
